import styled from 'styled-components';
import { focusVisibleStyles, standardTransitionStyles } from '../sharedStyles.ts';

export const STYTCH_CONTAINER_WIDTH = '464px';

// Apply styles not included in the stytch API (which seems very limited)
export const StytchLoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9375rem;
  height: 50%; // Places the error message lower on the screen

  // Styles from here down are for targeting stytch UI pieces that the stytch API
  // doesn't let us style directly
  * {
    // This is here specifically for the hairline separating username + password
    // inputs from oath buttons
    div {
      border-color: var(--grayscale-100) !important;
    }
  }

  div[size~='header'] {
    font-family: 'Space Grotesk', system-ui, Helvetica, Arial, sans-serif;
    font-size: 1.75rem;
  }

  div[size~='body'] {
    font-size: 0.9375rem;
  }

  button,
  input {
    font-size: 0.9375rem;
    height: 2.75rem;
    ${focusVisibleStyles}
    ${standardTransitionStyles}
  }

  button {
    // For random buttons that don't fall into the 'primary'
    // or 'secondary' categories
    border-radius: var(--border-radius-medium);

    &:disabled {
      background-color: rgba(236, 233, 240, 0.5);
      border-color: rgba(236, 233, 240, 0.5);
      color: var(--grayscale-300);
    }
  }

  // I really hate to do this, but the way the input is set up
  // makes the focus outline look strange
  input[name~='password'] {
    &:focus-visible {
      box-shadow: none;
    }
  }

  input {
    padding: 0 0.75rem;
  }

  // Increase margin between logo and text
  #oauth-google > div,
  #oauth-microsoft > div {
    gap: 0.75rem;
  }

  #oauth-google,
  [type='submit'] {
    &:hover {
      background-color: var(--grayscale-50);
      border-color: var(--grayscale-50);
    }
  }

  #oauth-microsoft {
    background-color: var(--purple-900);
    border-color: var(--purple-900);
    color: var(--white);

    &:hover {
      background-color: var(--grayscale-600);
      border-color: var(--grayscale-600);
    }
  }
`;

// Apply custom styles to the pre-built UI components through stytch API
// This is passed into the `styles` prop of the StytchB2B component
export const stytchLoginApiStyles = {
  fontFamily: "'DM Sans', system-ui, Helvetica, Arial, sans-serif",
  textColor: 'var(--grayscale-900)',
  headerTextFont: "'Space Grotesk', system-ui, Helvetica, Arial, sans-serif",
  hideHeaderText: false,
  container: {
    backgroundColor: 'var(--white)',
    width: STYTCH_CONTAINER_WIDTH,
    borderRadius: 'var(--border-radius-large)',
    borderColor: 'var(--grayscale-100)',
  },
  colors: {
    // "primary" color affects the header text color
    // !important is needed to target the "or" text
    primary: 'var(--grayscale-900) !important',
    // "secondary" color affects field labels and link text
    secondary: 'var(--grayscale-900)',
    success: 'var(--green-400)',
    error: 'var(--red-400)',
  },
  buttons: {
    // Continue with email button
    primary: {
      borderRadius: 'var(--border-radius-medium)',
      backgroundColor: 'var(--white)',
      borderColor: 'var(--grayscale-100)',
      textColor: 'var(--grayscale-900)',
    },
    // Oauth buttons
    // The reverse of these colors is used for the org "avatars" with initials inside
    // (the backgroundColor is used for the initials and the textColor is the background color of the avatar)
    secondary: {
      borderRadius: 'var(--border-radius-medium)',
      backgroundColor: 'var(--white)',
      borderColor: 'var(--grayscale-100)',
      textColor: 'var(--grayscale-900)',
    },
  },
  inputs: {
    borderRadius: 'var(--border-radius-medium)',
    borderColor: 'var(--grayscale-100)',
    placeholderColor: 'var(--grayscale-100)',
    fontSize: '20px',
  },
};
